import React from 'react'

import AnnualLeaveListItem from './AnnualLeaveListItem'

const AnnualLeaveList = ({data, canApprove, onApprove, onReject, onCancel, onEdit}) => {
  return (
    <div className="d-flex flex-column">
      {data && 
      data.sort((a, b) => a.status_id - b.status_id)
      .map(item => (
        <AnnualLeaveListItem 
          key={item.id} 
          canApprove={canApprove} 
          onApprove={onApprove} 
          onReject={onReject} 
          onCancel={onCancel}
          onEdit={onEdit}
          {...item}
        />))}
    </div>
  )
}

export default AnnualLeaveList